import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto w-full border-t border-white/[0.1] bg-[#16161e] text-slate-300" style={{ backgroundColor: '#16161e' }}>
      <div className="h-px w-full bg-gradient-to-r from-transparent via-violet-500/40 to-transparent" aria-hidden />
      <div className="mx-auto max-w-7xl px-4 py-6 md:px-6 md:py-7">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 md:justify-between md:gap-6">
          {/* Header logo */}
          <div className="flex items-center shrink-0 mr-6 md:mr-8">
            <img
              src={`${process.env.PUBLIC_URL || ''}/logo.png`}
              alt="YuvanAPI"
              className="h-6 w-auto max-w-[90px] object-contain"
            />
          </div>

          {/* Copyright */}
          <p className="text-xs text-slate-500 m-0 shrink-0">
            © {currentYear} YuvanAPI. All rights reserved.
          </p>

          {/* Privacy · Terms */}
          <div className="flex items-center gap-2 shrink-0">
            <a href="#" className="text-xs text-slate-500 hover:text-violet-300 transition-colors no-underline">Privacy</a>
            <span className="text-slate-600 select-none text-xs" aria-hidden>·</span>
            <a href="#" className="text-xs text-slate-500 hover:text-violet-300 transition-colors no-underline">Terms</a>
          </div>

          {/* Design & Developed By Algobasket */}
          <p className="text-xs text-slate-500 m-0 shrink-0">
            Design & Developed By{' '}
            <span className="font-semibold text-violet-400 tracking-wide">Algobasket</span>
          </p>
        </div>
      </div>
    </footer>
  );
};export default Footer;